"use client";

import { createContext, useContext, useState } from "react";
import { Snackbar, Alert, Box } from "@mui/material";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success",
    iconInline: null, // optional inline icon
  });

  const showToast = (message, severity = "success", iconInline = null) =>
    setToast({ open: true, message, severity, iconInline });

  const closeToast = () => setToast({ ...toast, open: false });

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Snackbar
        open={toast.open}
        autoHideDuration={2000}
        onClose={closeToast}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ mt: 2, ml: 2 }}
      >
        <Alert
          onClose={closeToast}
          severity={toast.severity}
          icon={false} // disable default icon
          sx={{
            backgroundColor:
              toast.severity === "success" ? "#d4edda" : "#f8d7da",
            color: toast.severity === "success" ? "#155724" : "#721c24",
            boxShadow: 3,
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            gap: 1,
            whiteSpace: "nowrap", // ✅ prevents line break
            px: 2, // padding left/right
          }}
        >
          {toast.iconInline && (
            <Box sx={{ display: "inline-flex", alignItems: "center", mr: 1 }}>
              {toast.iconInline}
            </Box>
          )}
          <Box sx={{ display: "inline" }}>{toast.message}</Box>
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
